import React, { Component } from 'react';
import { Tree } from 'antd';

// 共参
const TreeNode = Tree.TreeNode;

class NewTree extends Component {

	// 点击树节点
	onChapterSelect = (selectedKeys, other) => {
		const { onSelect } = this.props;
		onSelect && onSelect(selectedKeys, other)
	}

	render() {
		const { list, showLine } = this.props;
		const loop = data => data.map((item) => {
			if (item.children && item.children.length) {
				return <TreeNode key={item.key} title={item.title}>{loop(item.children)}</TreeNode>;
			}
			return <TreeNode key={item.key} title={item.title} />;
		});
		return (
			<Tree
				showLine={showLine}
		        className="relative-tree"
		        onSelect={this.onChapterSelect}

		    >
		    	{loop(list)}
		    </Tree>
		)
	}
}

export default NewTree;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/component/new_tree.js